import {BaseButton, SecondaryButton} from "components/buttons"
import {handleError, toastSuccess} from "helpers"
import {useContext, useState, useEffect} from "react"
import {BasePopup} from "uiKit"
import styles from "./VoiceCallForwarding.module.css"
import StaffSelect from "components/StaffSelect"
import {VoiceCallContext} from "context/VoiceCallContext"
import {studentCallLogService} from "services"
import {UserAutocomplete} from "types/user"

type Props = {
    open: boolean
    departmentId?: number
    onClose: () => void
}

export function VoiceCallForwarding(props: Props) {
    const {open, onClose, departmentId} = props
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [selectedStaff, setSelectedStaff] = useState<UserAutocomplete | null>(null)
    const {activeCall} = useContext(VoiceCallContext)

    // Reset selected staff when modal closes
    useEffect(() => {
        if (!open) {
            setSelectedStaff(null)
        }
    }, [open])

    const onSubmit = async () => {
        if (!selectedStaff) {
            handleError(new Error("Please select a staff member to forward the call to"))
            return
        }

        if (!activeCall) {
            handleError(new Error("No active call found"))
            return
        }

        // Extract callSid from activeCall
        const callSid = activeCall.parameters?.CallSid
        if (!callSid) {
            handleError(new Error("Unable to get call information"))
            return
        }

        // Get profileId from selected staff
        const staffProfileId = selectedStaff.profileId
        if (!staffProfileId) {
            handleError(new Error("Selected staff does not have a valid profile ID"))
            return
        }

        try {
            setIsSubmitting(true)
            await studentCallLogService.forwardCall({
                browserCallId: callSid,
                staffProfileId
            })
            toastSuccess("Call forwarded successfully", "The call has been forwarded to the selected staff member")
            setSelectedStaff(null)
            onClose()
        } catch (e) {
            handleError(e)
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <BasePopup
            isShow={open}
            onClose={onClose}
            leftIcon="FORWARD"
            leftIconColor="#fff"
            width="40vw"
            closable
            destroyOnClose>
            <div className={styles.headingTitle}>Call Forwarding</div>
            <StaffSelect
                departmentId={departmentId}
                placeholder="Select staff to forward call"
                value={selectedStaff}
                onChange={(staff: UserAutocomplete | null) => setSelectedStaff(staff)}
            />
            <div className={styles.doneBtn}>
                <SecondaryButton
                    title="Cancel"
                    onClick={() => {
                        setSelectedStaff(null)
                        onClose()
                    }}
                />
                <BaseButton title="OK" onClick={onSubmit} className={styles.saveBtn} loading={isSubmitting} />
            </div>
        </BasePopup>
    )
}
